import { OutstandingClosingBinders } from './OutstandingClosingBinders';

export default OutstandingClosingBinders;
